import storeHelper from "./storeHelper";

export default {
  mixins: [ storeHelper ],
  data() {
    return {
      searchFocus: false,
      isSearching: false
    }
  },

  computed: {
    name() {
      return this.type || this.resourceName;
    },
    searchFraze: {
      get() {
        return this[this.name].filters && this[this.name].filters.query
      },
      set(value) {
        this.setFilterParam(this.name, 'query', value)
      },
    },
    searchType: {
      get() {
        return this[this.name].filters && this[this.name].filters.search_type
      },
      set(value) {
        this.setFilterParam(this.name, 'search_type', value)
      },
    },
    resourceUrl() {
      let url = `/projects/${this.project_id}/searches`
      if(this.name === 'group_library') url += '/group_library'
      else if (this.name === 'tag_library') url += '/tag_library'
      return url
    }
  },

  methods: {
    clearSearch() {
      this.isSearching = true;
      this.resetPaginatedResource(this.name)
      this.setFilterParam(this.name, 'query', null)
      this.getPaginatedResource({key: this.name, url: this.resourceUrl})
        .catch(() => this.notifyStoreError())
        .finally(() => this.isSearching = false)
    },
    searchQueries() {
      this.isSearching = true;
      this.resetPaginatedResource(this.name)
      this.getPaginatedResource({key: this.name,  url: this.resourceUrl})
        .catch(() => this.notifyStoreError())
        .finally(() => this.isSearching = false)
    },
  },
}